import { Toast as ToastBS, ToastContainer } from 'react-bootstrap';
import { FaXmark } from 'react-icons/fa6';

interface ToastProps {
  show: boolean;
  onClose: any;
  mensagem?: string;
}

export default function Toast({ show, onClose, mensagem }: ToastProps) {
  return (
    <div>
      <ToastContainer position="top-end">
        <ToastBS
          show={show}
          onClose={onClose}
          style={{
            backgroundColor: '#168821',
            borderRadius: '20px',
            color: '#fff',
            width: '15vw',
          }}
        >
          <ToastBS.Body
            style={{
              display: 'd-flex',
              flexDirection: 'column',
              flexWrap: 'nowrap',
              alignItems: 'start',
              justifyContent: 'flex-start',
              width: 'auto',
              margin: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1vh',
                font: 'normal normal 1rem Rawline',
              }}
            >
              <span>Solicitação efetuada!</span>
              <FaXmark onClick={onClose} style={{ cursor: 'pointer' }} />
            </div>
            <div
              style={{
                display: 'flex',
                maxWidth: '80%',
                alignItems: 'start',
                justifyContent: 'start',
                font: 'normal normal 0.9rem Rawline',
              }}
            >
              {mensagem ? (
                <span>{mensagem}</span>
              ) : (
                <span>
                  Um e-mail foi enviado para a sua conta contendo uma nova senha
                  de acesso.
                </span>
              )}
            </div>
          </ToastBS.Body>
        </ToastBS>
      </ToastContainer>
    </div>
  );
}
